// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__1Ob2N","errors":"Errors_errors__2l7Rb"};